// Namespace "public" — fragment "promo" (BUG-019).
//
// THE WORDING IS LOAD-BEARING, not decoration. `GET /api/promo-codes/{code}` is a
// PREVIEW: it describes a code as it stands right now, and the server re-decides at
// payment (`promos.resolve_discount` → 400 PROMO_INVALID). A label reading "−20 %
// applied" would promise a price this screen cannot guarantee — the code can expire, be
// deactivated or run out between the click on "Apply" and the click on "Pay". Every
// locale therefore says APPLIED AT PAYMENT, and none of them states a new total.
//
// `promo.invalid` is the single mapping of the server's stable `PROMO_INVALID`. One
// message for all seven refusals (unknown, inactive, expired, maxed out, wrong kind,
// wrong currency, basket too small), matching the backend, which deliberately does not
// say which one it is — telling a stranger why would turn the endpoint into an oracle
// for enumerating a practice's codes.
export default {
  fr: {
    "promo.label": "Code promo",
    "promo.placeholder": "Ex. PRINTEMPS20",
    "promo.apply": "Appliquer",
    "promo.remove": "Retirer",
    "promo.appliedPct": "−{value} % appliqué au paiement",
    "promo.appliedAmount": "−{value} appliqué au paiement",
    "promo.minSubtotal": "À partir de {value} d'achat",
    "promo.invalid": "Ce code promo ne s'applique pas à cet achat.",
    "promo.notRedeemable": "Ce code n'est plus utilisable.",
    "promo.checking": "Vérification…",
  },
  en: {
    "promo.label": "Promo code",
    "promo.placeholder": "e.g. SPRING20",
    "promo.apply": "Apply",
    "promo.remove": "Remove",
    "promo.appliedPct": "−{value}% applied at payment",
    "promo.appliedAmount": "−{value} applied at payment",
    "promo.minSubtotal": "On orders of {value} or more",
    "promo.invalid": "This promo code does not apply to this purchase.",
    "promo.notRedeemable": "This code can no longer be used.",
    "promo.checking": "Checking…",
  },
  es: {
    "promo.label": "Código promocional",
    "promo.placeholder": "Ej. PRIMAVERA20",
    "promo.apply": "Aplicar",
    "promo.remove": "Quitar",
    "promo.appliedPct": "−{value} % aplicado en el pago",
    "promo.appliedAmount": "−{value} aplicado en el pago",
    "promo.minSubtotal": "En compras de {value} o más",
    "promo.invalid": "Este código promocional no se aplica a esta compra.",
    "promo.notRedeemable": "Este código ya no se puede usar.",
    "promo.checking": "Verificando…",
  },
};
